import * as Yup from 'yup'

import required from '@galo-monitor/forms/validators/required.validator'

const pesticideSchema = ({ t }) => Yup.object().shape({
  name: required({ t })(Yup.string()),
  defensive_type: required({ t })(Yup.string()),
  origin: required({ t })(Yup.string()),
  formulation: required({ t })(Yup.string()),
  active_ingredient: Yup.string(),
  defensives_maker_name: required({ t })(Yup.string())
})

export default pesticideSchema
